export function getIconColor() {
  return 'var(--color-white)'
}
